module.exports = __webpack_public_path__ + "static/media/illustration-food-groceries.436b2398.svg";